import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    powerInKw: 15,
    kSpringOne: 1.6,
    presetSpringOne: 27,
    kSpringTwo: 2.4,
    positionSpringTwo: 38,
    displacement: 100,
    setting1Offset: 37,
    setting2Offset: 17,
    override: 0,
    showIdealCurve: true, 
    showSpringCurve: true,
    doubleSpring: true,
};

export const drawingBoardSlice = createSlice({
    name: 'drawingBoard',
    initialState,
    reducers: {
        setPower: (state, action) => {
            state.powerInKw = action.payload;
        },
        setKSpringOne: (state, action) => {
            state.kSpringOne = action.payload;
        },
        setPresetSpringOne: (state, action) => {
            state.presetSpringOne = action.payload;
        },
        setKSpringTwo: (state, action) => {
            state.kSpringTwo = action.payload;
        },
        setPositionSpringTwo: (state, action) => {
            state.positionSpringTwo = action.payload;
        },
        setDisplacement: (state, action) => {
            state.displacement = action.payload;
        },
        setSetting1Offset: (state, action) => {
            state.setting1Offset = action.payload;
        },
        setSetting2Offset: (state, action) => {
            state.setting2Offset = action.payload;
        },
        setOverride: (state, action) => {
            state.override = action.payload;
        },
        toggleIdealCurve: (state) => {
            state.showIdealCurve = !state.showIdealCurve;
        },
        toggleSpringCurve: (state) => {
            state.showSpringCurve = !state.showSpringCurve;
        },
        toggleDoubleSpring: (state) => {
            state.doubleSpring = !state.doubleSpring;
        },
    }
});

export const { 
    setPower,
    setKSpringOne,
    setPresetSpringOne,
    setKSpringTwo,
    setPositionSpringTwo,
    setDisplacement,
    setSetting1Offset,
    setSetting2Offset,
    setOverride,
    toggleIdealCurve,
    toggleSpringCurve,
    toggleDoubleSpring,
 } = drawingBoardSlice.actions;

export const selectPower = (state) => state.drawingBoard.powerInKw;
export const selectKSpringOne = (state) => state.drawingBoard.kSpringOne;
export const selectPresetSpringOne = (state) => state.drawingBoard.presetSpringOne;
export const selectKSpringTwo = (state) => state.drawingBoard.kSpringTwo;
export const selectPositionSpringTwo = (state) => state.drawingBoard.positionSpringTwo;
export const selectDisplacement = (state) => state.drawingBoard.displacement;
export const selectSetting1Offset = (state) => state.drawingBoard.setting1Offset;
export const selectSetting2Offset = (state) => state.drawingBoard.setting2Offset;
export const selectOverride = (state) => state.drawingBoard.override;
export const selectShowIdealCurve = (state) => state.drawingBoard.showIdealCurve;
export const selectShowSpringCurve = (state) => state.drawingBoard.showSpringCurve;
export const selectDoubleSpring = (state) => state.drawingBoard.doubleSpring;

export default drawingBoardSlice.reducer;
